var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 2.5H2.5v6.25C2.5 12.196 5.304 15 8.75 15S15 12.196 15 8.75V2.5h1.25c.345 0 .625-.28.625-.625V.625c0-.345-.28-.625-.625-.625h-5.625C10.28 0 10 .28 10 .625v1.25c0 .345.28.625.625.625h1.25v6.25c0 1.726-1.4 3.125-3.125 3.125-1.726 0-3.125-1.4-3.125-3.125V2.5h1.25c.345 0 .625-.28.625-.625V.625C7.5.28 7.22 0 6.875 0H1.25C.905 0 .625.28.625.625v1.25c0 .345.28.625.625.625zm15.625 15H.625c-.345 0-.625.28-.625.625v1.25c0 .345.28.625.625.625h16.25c.345 0 .625-.28.625-.625v-1.25c0-.345-.28-.625-.625-.625z",
    transform: "translate(4 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.c833883351ac2c12e9ad75716ffa5be3.svg";
export { ForwardRef as ReactComponent };